export default __webpack_public_path__ + "static/media/link-copied.7d5703d6.svg";